export enum PaymentType {
    CASH = "cash",
    FINANCE = "finance",
    LEASE = "lease",
}

export enum PaymentFrequency {
    WEEKLY = "weekly",
    BIWEEKLY = "biweekly",
    MONTHLY = "monthly",
}
